import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsent, GA4_ID } from './CookieConsent';

/**
 * Loads Google Analytics 4 only AFTER the user has actively consented to the
 * "statistics" category — and only if a GA4_MEASUREMENT_ID is configured
 * via REACT_APP_GA4_MEASUREMENT_ID.
 *
 * Before consent: zero requests to google-analytics.com / googletagmanager.com.
 * IP anonymisation (`anonymize_ip`) is enabled by default.
 */
const injectGtag = (id) => {
  if (window.__gaInjected) return;
  window.__gaInjected = true;

  // gtag bootstrap
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', id, {
    anonymize_ip: true,
    allow_ad_personalization_signals: false,
    allow_google_signals: false,
  });

  const s = document.createElement('script');
  s.async = true;
  s.dataset.ga = '1';
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
};

// Kein Tracking im eingeloggten Bereich (Portal, Kanzlei-Bereich, Vorgänge)
const GESCHUETZT = /^\/(dashboard|portal|kanzlei|mandantenerfassung|meine-|team|admin|dokumente|profil|downloads|signatur|akontozahlung|ratenzahlung|meine-raten|sepa-lastschrift|rueckruf|notfallkontakt|anmelden|auth)/;
export const istGeschuetzt = (path) => GESCHUETZT.test(path || window.location.pathname);

const GoogleAnalytics = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const ph = window.posthog;
    if (!ph?.opt_in_capturing) return;
    if (getConsent()?.statistics && !istGeschuetzt(pathname)) ph.opt_in_capturing();
    else ph.opt_out_capturing();
  }, [pathname]);

  useEffect(() => {
    const id = GA4_ID;
    if (!id) return; // No measurement ID configured -> never load GA4

    const apply = () => {
      const c = getConsent();
      if (c?.statistics && !istGeschuetzt()) injectGtag(id);
    };

    apply();
    const onConsent = () => apply();
    window.addEventListener('kp:consent', onConsent);
    return () => window.removeEventListener('kp:consent', onConsent);
  }, []);

  return null;
};

export default GoogleAnalytics;
